export default __webpack_public_path__ + "static/media/video-2017.9d70bfcb.webp";